import React, { useEffect, useState } from 'react';
import { Typography } from '@mui/material';

const Timer = ({ initialTime = 15, timerStyle, timeEnd }) => {
    const [time, setTime] = useState(initialTime);


    useEffect(() => {
        if (initialTime) {
            setTime(initialTime);

            const interval = setInterval(() => {
                setTime(prevTime => {
                    if (prevTime <= 1) {
                        clearInterval(interval);
                        setTimeout(() => {
                            if (timeEnd && typeof timeEnd === 'function') {
                                timeEnd(); // 👈 call the function when time ends
                            }
                            return 0;
                        }, 1000);
                    }
                    return prevTime - 1;
                });
            }, 1000);

            return () => clearInterval(interval);
        }
    }, [initialTime, timeEnd]);

    if (!initialTime) {
        return null;
    }

    const formatTime = (seconds) => {
        const minutes = Math.floor(seconds / 60);
        const remainingSeconds = seconds % 60;
        return `${minutes}:${remainingSeconds < 10 ? '0' : ''}${remainingSeconds}`;
    };

    return (
        <Typography
            variant="subtitle1"
            sx={{
                fontSize: "13.5px",
                color: "dark.main2",
                textAlign: "center",
                ...timerStyle,
            }}
        >
            Please wait <strong style={{ color: "#FF0000", fontSize: "14,5px" }}>{formatTime(time)}</strong> to resend your OTP.
        </Typography>
    );
};

export default Timer;
